import Vue from 'vue';
import routes from './routes';
import Router from 'vue-router';

import Cookies from 'js-cookie';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL || '/',
    routes,
    scrollBehavior() {
        return { y: 0 };
    }
});

router.beforeEach(async function(to, from, next) {
    // check the 'access_cookie', if our route requires auth
    if (to.matched.some(record => record.meta.checkAuth)) {
        // user logged in, redirect the user to wherever he/she is going unless login & register pages
        if (Cookies.get('access_cookie')) {
            if(Cookies.get('access_level') != 'user') {
                Cookies.remove('access_cookie');
                next({ name: 'Login' });
            }
            else if (to.name == 'Login' || to.name == 'Register' || to.name == 'PreRegister') {
                next({ name: 'Khanesh' })
            } else {
                next();
            }
        }
        // if user does not logged in yet, redirect the user to login page
        else {
            if (to.name != 'Login' && to.name != 'Register' && to.name != 'PreRegister') {
                next({ name: 'Login' });
            } else {
                next()
            }
        }
    }
    // this route does not require auth
    else {
        next();
    }
});

// change the page title after each route redirection
const DEFAULT_TITLE = 'خبرگی';
router.afterEach((to) => {
    document.title = to.meta.title || DEFAULT_TITLE;

    // close our SideNav after route change
    if (document.getElementById('mySidenav')) {
        document.getElementById('mySidenav').style.width = '0';
    }
});

export default router;
